import { Project } from '../shared/models/Project';
import {
  CANCEL_REFRESH_REPORT_STATS,
  GET_REPORT_PROJECTS_SUCCESS,
  GET_REPORT_STATS_SUCCESS,
  REFRESH_REPORT_STATS_REQUEST,
  ReportsAction,
  SET_REPORT_FILTERS
} from './reports.actions';
import { createSelector } from 'reselect';
import { ReportFilters } from './report-filters/ReportFilters';
import { Stats } from '../stats/stats.model';
import { sumImpressions } from '../../shared/utils/sumImpressions';

export interface ReportsState {
  projects: Project[];
  filters?: ReportFilters;
  stats?: Stats;
}

export const initialState: ReportsState = { projects: [] };

export function reportsReducer(state: ReportsState = initialState, action: ReportsAction): ReportsState {
  switch (action.type) {
    case GET_REPORT_PROJECTS_SUCCESS:
      const projects: Project[] = action.payload.map(({ id, name }) => ({ id, name }));
      return { ...state, projects: projects };
    case SET_REPORT_FILTERS:
      return { ...state, filters: action.payload };
    case GET_REPORT_STATS_SUCCESS:
      const stats: Stats = {
        impressions: sumImpressions(action.payload.popup) || 0,
        leads: action.payload.popup.popupSubmitted || 0,
        contacted: action.payload.record.callsCount || 0,
        successes: action.payload.record.successContactsCount || 0,
        timesToFirstContact: action.payload.record.timesToFirstContact || []
      };
      return { ...state, stats };
    case REFRESH_REPORT_STATS_REQUEST:
      return { ...state, filters: { ...state.filters, liveModeEnabled: true } };
    case CANCEL_REFRESH_REPORT_STATS:
      return { ...state, filters: { ...state.filters, liveModeEnabled: false } };
    default: {
      return state;
    }
  }
}

const getProjects = (reportState: ReportsState): Project[] => reportState.projects;
const getFilters = (reportState: ReportsState): ReportFilters => reportState.filters;
const getStats = (reportState: ReportsState): Stats => reportState.stats;

export const getMainReportsSelector = (state): ReportsState => state.leadGeneration.reports;

export const getProjectsReportSelector = createSelector(getMainReportsSelector, getProjects);
export const getReportStatsSelector = createSelector(getMainReportsSelector, getStats);
export const getReportFiltersSelector = createSelector(getMainReportsSelector, getFilters);
